export class PoliciesController {
    constructor($state, $scope, JFrogTableViewOptions, PolicyDao, JFrogModal, XRayUIState) {
        this.$scope = $scope;
        this.$state = $state;
        this.modal = JFrogModal;
        this.XRayUIState = XRayUIState;
        this.TemplateGenerator = JFrogTableViewOptions.cellTemplateGenerators;
        this.tableViewOptions = new JFrogTableViewOptions($scope);
        this.PolicyDao = PolicyDao;
        this.createGrid()
        this.getPolicies();
    }

    createGrid() {
        this.canEdit = window.store.getters['common/context/GET_XRAY_PERMISSIONS'].manage_policies;
        this.tableViewOptions.setId('policies-table')
            .setObjectName('Policy/Policies')
            .setColumns(this.getColumns())
            .setRowsPerPage(20)
            .setActions(this.getActions())


        if (this.canEdit) {
            this.tableViewOptions.setNewEntityAction(() => {
                this.addPolicy();
                this.tableViewOptions.update();
            });

            this.tableViewOptions.emptyTableCallActionText = 'Add a new Policy';
            this.tableViewOptions.emptyTableAction = () => {
                this.addPolicy();
            }
        }
        //.setBatchActions(getBatchActions())


        this.tableViewOptions.on('row.clicked', (data) => {

            this.$state.go('policies.edit', {policyName: data.entity.name})
        })
        ;

        this.tableViewOptions.emptyTableText = 'Currently there are no Policies in the system.';

        this.tableViewOptions.newEntityCustomText = 'New Policy';

        this.tableViewOptions.sortBy('modified').reverseSortingDir();


    }


    getColumns() {
        return [
            {
                "header": "Name",
                "field": "name",
                'cellTemplate': `<div class="{{row.entity.priority}}"><a class="jf-link">{{row.entity.name}}</a></div>`,
                "filterable": true
            },
            {
                "header": "Type",
                "field": "type",
                'cellTemplate': `<div disable-tooltip-on-overflow style="display:flex;flex-direction:row"> <div style="line-height: 28px;flex-shrink:1" jf-tooltip-on-overflow>{{row.entity.type | capitalizeFirst}}</div></div>`,
                "allowGrouping": true,
                "filterable": true
            },
            {
                "header": "Watches",
                'field': 'watches',
                "cellTemplate": this.TemplateGenerator.listableColumn('row.entity.watches', 'row.entity.name'),
                "filterable": true
            },
            {
                "header": "Author",
                "field": "author",
                "cellTemplate": `<div  class="{{row.entity.author}}">{{row.entity.author}}</div>`,
                /* "headerCellTemplate": `<div>{{col.header}} ({{appScope.ctrl.runningId}})</div>`,*/
                "allowGrouping": true,
                "pixelWidthThreshold": 200
            },
            {
                "header": "Modified",
                'field': 'modified',
                "cellTemplate": `<div class="">{{row.entity.modified | formatDateBySysConfig}}</div>`,
                "pixelWidthThreshold": 170,
                "filterable": true
            }
        ]
    }


    getActions() {
        return [
            {
                icon: 'icon icon-artifactory-edit',
                tooltip: 'Edit',
                callback: (row) => this.$state.go('policies.edit', {policyName: row.name}),
                visibleWhen: (row) => this.canEdit
            },
            {
                icon: 'icon icon-copy',
                tooltip: 'Clone',
                callback: (row) => this.makeDuplicate(row),
                visibleWhen: (row) => this.canEdit
            },
            {
                icon: 'icon icon-clear',
                tooltip: 'Delete',
                callback: (row) => this.deleteItem(row),
                visibleWhen: (row) => this.canEdit
            }
        ];
    }

    makeDuplicate(row) {
        console.log("Need to make a copy object for edit", row);
        let copiedObj = {};
        copiedObj.name = `${row.name}-Copy`;
        copiedObj.type = row.type;
        copiedObj.rules = row.rules;
        if (row.description) {
            copiedObj.description = row.description;
        }

        this.XRayUIState.setState('policyCopy', copiedObj)
        this.$state.go('policies.new')
    }

    addPolicy() {
        this.$state.go('policies.new');
    }

    getPolicies() {
        this.PolicyDao.getAll().$promise.then((response) => {

            this.tableViewOptions.setData(response);
        });

    }

    deleteItem(row) {

        console.log("neectp remove po", row);
        if (row.watches && row.watches.length) {
            this.modal.confirm(`To delete this Policy (<strong>${row.name}</strong>), you must first remove it from the following Watches to which it is assigned: <br/><strong>${row.watches.join("<br/>")} </strong>`, "Delete Policy", {
                confirm: 'Close',
                cancel: ' '
            })
                .then(() => {

                });
        } else {
            this.modal.confirm(`Are you sure you want to delete <strong>${row.name} </strong> policy ?`)
                .then(() => {
                    this.PolicyDao.deletePolicy({}, {policyName: row.name}).$promise.then((response) => {
                        this.getPolicies();
                    });
                });
        }
    }
}



// WEBPACK FOOTER //
// ./modules/xray/states/policies/policies.controller.js